(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('talis-footer-nav')) {
    customElements.define(
      'talis-footer-nav',
      class TalisFooterNav extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelectorAll('details');
          this.mq = window.matchMedia('(max-width: 768px)');
          this.sync = this.sync.bind(this);
          if (this.mq.addEventListener) this.mq.addEventListener('change', this.sync);
          else this.mq.addListener(this.sync);
          this.sync();
        }

        disconnectedCallback() {
          if (!this.mq) return;
          if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.sync);
          else this.mq.removeListener(this.sync);
        }

        sync() {
          this.details.forEach((item) => {
            item.open = !this.mq.matches;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talis-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('talis-footer-nav')) {
    customElements.define(
      'talis-footer-nav',
      class TalisFooterNav extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelectorAll('details');
          this.mq = window.matchMedia('(max-width: 768px)');
          this.sync = this.sync.bind(this);
          if (this.mq.addEventListener) this.mq.addEventListener('change', this.sync);
          else this.mq.addListener(this.sync);
          this.sync();
        }

        disconnectedCallback() {
          if (!this.mq) return;
          if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.sync);
          else this.mq.removeListener(this.sync);
        }

        sync() {
          this.details.forEach((item) => {
            item.open = !this.mq.matches;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
